<template>
  <el-form :model="form" :rules="rules" ref="form">
    <div class="row">
      <div class="col-12 col-lg-3">
        <h4>Статус рекламации</h4>
        <el-form-item prop="claimProcessed">
          <el-select v-model="form.claimProcessed"
                     clearable @clear="form.claimProcessed = null"
                     class="w-100"
                     size="small"
                     placeholder="Выберите статус рекламации">
            <el-option v-for="option in claimStatuses" :key="option.id" :label="option.label" :value="option.value.toString()" />
          </el-select>
        </el-form-item>
      </div>
      <div class="col-12 col-lg-3">
        <h4>Статус заказа</h4>
        <el-form-item prop="statusIds">
          <el-select v-model="form.statusIds"
                     class="w-100"
                     multiple
                     size="small"
                     filterable
                     collapse-tags
                     placeholder="Выберите статус заказа">
            <el-option v-for="status in statuses" :key="status.id" :label="status.title" :value="status.id.toString()" />
          </el-select>
        </el-form-item>
      </div>

      <div class="col-12 col-lg-3">
        <h4>Тип заказа</h4>
        <el-form-item prop="serviceIds">
          <el-select size="small" class="w-100" filterable multiple collapse-tags
                     :loading="servicesDropFetchProgress"
                     v-model="form.serviceIds"
                     placeholder="Выберите услугу">
            <el-option v-for="option in servicesDropItems" :key="option.id" :label="option.displayName" :value="option.id.toString()" />
          </el-select>
        </el-form-item>
      </div>

      <div class="col-12 col-lg-3">
        <h4>Тип реестра</h4>
        <el-form-item prop="registryTypeIds">
          <el-select size="small" class="w-100" filterable multiple collapse-tags
                     :loading="registryTypesDropFetchProgress"
                     v-model="form.registryTypeIds"
                     placeholder="Выберите тип реестра">
            <el-option v-for="option in registryTypesDropItems" :key="option.id" :label="option.displayName" :value="option.id.toString()" />
          </el-select>
        </el-form-item>
      </div>

      <div class="col-12 col-lg-3">
        <h4>Магазин</h4>
        <el-form-item prop="shop">
          <el-input size="small" placeholder="Магазин" v-model="form.shop" />
        </el-form-item>
      </div>

      <div class="col-12 col-lg-3">
        <h4>Дата обработки</h4>
        <div class="row">
          <div class="col-6">
            <el-date-picker v-model="form.claimProcessingDateFrom" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy" size="small"
                            class="w-100" placeholder="с" :pickerOptions="pickerOptions" />
          </div>
          <div class="col-6 pl-0">
            <el-date-picker v-model="form.claimProcessingDateTo" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy" size="small"
                            class="w-100" placeholder="по" :pickerOptions="pickerOptions" />
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-3">
        <h4>Дата рекламации</h4>
        <div class="row">
          <div class="col-6">
            <el-date-picker v-model="form.claimCreationDateFrom" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy" size="small"
                            class="w-100" placeholder="с" :pickerOptions="pickerOptions" />
          </div>
          <div class="col-6 pl-0">
            <el-date-picker v-model="form.claimCreationDateTo" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy" size="small"
                            class="w-100" placeholder="по" :pickerOptions="pickerOptions" />
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <h4>Дата оказания услуги</h4>
        <div class="row">
          <div class="col-6">
            <el-date-picker v-model="form.workDateFrom" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy" size="small"
                            class="w-100" placeholder="с" :pickerOptions="pickerOptions" />
          </div>
          <div class="col-6 pl-0">
            <el-date-picker v-model="form.workDateTo" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy" size="small"
                            class="w-100" placeholder="по" :pickerOptions="pickerOptions" />
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3" v-if="$isAccess($userRoles.Admin, $userRoles.Specialist)">
        <h4>Подрядчик по заказу</h4>
        <el-form-item prop="contractorIds">
          <el-select size="small" multiple filterable collapse-tags clearable
                     class="w-100"
                     v-model="form.contractorIds"
                     :loading="contractorsDropFetchProgress"
                     placeholder="Выберите подрядчика">
            <el-option
              v-for="option in contractorsDropItems"
              :key="option.id"
              :label="option.name"
              :value="option.id.toString()">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="col-12 col-lg-3" v-if="$isAccess($userRoles.Admin, $userRoles.Specialist, $userRoles.Dispatcher)">
        <h4>Исполнитель по заказу</h4>
        <el-form-item prop="contractorIds">
          <el-select size="small" multiple filterable collapse-tags clearable
                     class="w-100"
                     v-model="form.workerId"
                     :loading="contractorsDropFetchProgress"
                     placeholder="Выберите исполнителя">
            <el-option
              v-for="option in workersDropItems"
              :key="option.id"
              :label="option.fullName"
              :value="option.id.toString()">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div class="col-12 col-lg-3">
        <h4>Причина отмены заказа</h4>
        <el-form-item prop="reasonIds">
          <el-select v-model="form.cancellationReasonIds"
                     multiple filterable
                     collapse-tags class="w-100"
                     size="small"
                     placeholder="Выберите причину">
            <el-option v-for="item in cancellations" :key="item.id" :label="item.displayName" :value="item.id.toString()" />
          </el-select>
        </el-form-item>
      </div>
      <div class="col-12 col-lg-3">
        <h4>Причина рекламации</h4>
        <el-form-item prop="claimReasonIds">
          <el-select v-model="form.claimReasonIds"
                     multiple filterable
                     collapse-tags class="w-100"
                     size="small"
                     placeholder="Выберите причину">
            <el-option v-for="item in claims" :key="item.id" :label="item.displayName" :value="item.id.toString()" />
          </el-select>
        </el-form-item>
      </div>
    </div>

    <div>
      <el-button size="small" @click="onClear" :disabled="fetchProgress">Сбросить</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="fetchProgress">Применить</el-button>
    </div>
  </el-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import claimStatuses from '@/commons/constants/claimStatuses';
import { initialState } from '@/store/modules/orders';

const DEFAULT_FORM = () => {
  const form = initialState().filter;
  delete form.search;
  return form;
};

export default {
  props: {
    visible: Boolean,
    updateUrl: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    claimStatuses,
    form: { ...DEFAULT_FORM() },
    pickerOptions: {
      firstDayOfWeek: 1,
    },
    rules: {},
  }),
  computed: {
    ...mapGetters({
      fetchProgress: 'orders/fetchProgress',
      filter: 'orders/filter',
      statuses: 'orders/statuses',
      cancellations: 'orderCancellationReasonsDrop/items',
      claims: 'claimReasonsDrop/items',
      servicesDropItems: 'servicesDrop/items',
      servicesDropFetchProgress: 'servicesDrop/fetchProgress',
      registryTypesDropItems: 'registryTypesDrop/items',
      registryTypesDropFetchProgress: 'registryTypesDrop/fetchProgress',
      contractorsDropItems: 'contractorsDrop/items',
      workersDropItems: 'contractorsDrop/workers',
      contractorsDropFetchProgress: 'contractorsDrop/fetchProgress',
    }),
  },
  methods: {
    ...mapMutations({
      setFilterValue: 'orders/setFilterValue',
      setPage: 'orders/setPage',
    }),
    ...mapActions({
      fetchItems: 'orders/fetchItems',
      fetchStatuses: 'orders/fetchStatuses',
      fetchCancellations: 'orderCancellationReasonsDrop/fetchItems',
      fetchClaims: 'claimReasonsDrop/fetchItems',
      servicesDropFetchItems: 'servicesDrop/fetchItems',
      registryTypesDropFetchItems: 'registryTypesDrop/fetchItems',
      contractorsDropFetchItems: 'contractorsDrop/fetchItems',
    }),
    fillForm() {
      for (const key in this.form) {
        this.form[key] = this.filter[key];
      }
    },
    onClear() {
      this.form = { ...DEFAULT_FORM() };
    },
    setFilterForm() {
      for (const key in this.form) {
        this.setFilterValue({ key, value: this.form[key] });
      }
    },
    onSubmit() {
      this.setFilterForm();
      this.setPage(1);
      this.updateUrl();
      this.fetchItems();
      // .then(() => {
      //   this.$emit('update:visible', false);
      // });
    },
  },
  created() {
    this.fetchStatuses();
    this.fetchClaims();
    this.fetchCancellations();
    this.servicesDropFetchItems();
    this.registryTypesDropFetchItems();
    this.contractorsDropFetchItems();
    this.fillForm();
  },
};
</script>
<style lang="scss" module>
.filter {
  h3 {
    font-size: 16px !important;
    margin: 8px 0;
  }
}
</style>
